<template>
  <div
    class=""
    ref="searchFilterContainer"
    :class="{
      'badh-[120px] h-20': !onlySearchIconOnCollapse,
      'h-8 w-8': onlySearchIconOnCollapse
    }"
  >
    <div class="w-full" ref="searchFilterComponent">
      <div
        class="duration-300"
        :class="{
          'bg-white  pb-4 ': searchIsActivated,
          '': !searchIsActivated
        }"
      >
        <div
          :class="{ 'mobile-status-padding': searchIsActivated }"
          class="duration-300"
        ></div>

        <div
          class="py-2 duration-300"
          :class="{
            '!p-0': onlySearchIconOnCollapse && !searchIsActivated
          }"
        ></div>
        <div
          class="duration-300 title-color px-6 text-2xl font-bold flex justify-between"
          :class="{
            'h-[1.2lh] ': searchIsActivated,
            'h-0 opacity-0': !searchIsActivated
          }"
        >
          Recherche
          <div @click="disactivateSearch">
            <ColorImg
              src="/images/all/close.svg"
              class="w-8 h-8 bg-secondary"
              alt="Fermer"
            />
          </div>
        </div>

        <div
          class="px-6 relative duration-300"
          :class="{
            '!p-0': onlySearchIconOnCollapse && !searchIsActivated
          }"
          @click="
            () => {
              if (onlySearchIconOnCollapse && !searchIsActivated)
                manualActivateSearch();
            }
          "
        >
          <input
            v-model="searchValue"
            type="search"
            placeholder="On s'fait un rapidoo ?"
            class="bg-slate-100 w-full px-12 rounded-2xl h-[3.5rem]"
          />
          <div
            class="absolute w-12 h-[3.5rem] flex items-center justify-center left-6 top-0 pointer-events-none"
          >
            <ColorImg
              src="/images/icons/search.svg"
              class="w-6 h-6 bg-secondary"
              alt="Recherche"
            />
          </div>
          <div
            class="absolute w-12 h-[3.5rem] flex items-center justify-center right-6 top-0"
            @click="handleFiltersClick"
          >
            <ColorImg
              src="/images/icons/filter-outline.svg"
              class="w-6 h-6 bg-secondary"
              alt="Filtres"
            />
            <div
              v-if="nbFilters"
              class="absolute rounded-full w-6 h-6 text-sm flex items-center justify-center right-0 bottom-0 translate-y-1/2 font-bold translate-x-1/3 bg-primary text-white"
            >
              {{ nbFilters }}
            </div>
          </div>
        </div>
        <div class="py-1"></div>
        <div
          class="duration-300 relative z-[2]"
          :class="{
            noting: searchIsActivated,
            'opacity-0': !searchIsActivated
          }"
        >
          <CategoriesFiltersTags class="px-6" />
        </div>
      </div>
    </div>
    <div
      class="fixed z-[3] w-full h-full top-0 left-0 duration-300 overflow-auto"
      :class="{
        'bg-white pointer-events-auto ': searchIsActivated,
        'pointer-events-none opacity-0': !searchIsActivated
      }"
    >
      <div class="w-full pt-[150px] pb-4 flex flex-col h-full">
        <div class="mobile-status-padding shrink-0"></div>
        
        <!-- Onglets Plats / Restaurants -->
        <div class="mx-6 mb-4 shrink-0">
          <div class="bg-slate-100/80 rounded-2xl p-1.5 flex gap-2 shadow-inner">
            <button
              class="flex-1 py-2.5 px-3 rounded-xl text-sm font-semibold transition-all duration-300"
              :class="[
                visibleTab === 'dishes'
                  ? 'bg-white text-primary shadow-lg shadow-primary/20'
                  : 'text-slate-500 hover:text-slate-700 hover:bg-white/50'
              ]"
              @click="visibleTab = 'dishes'"
            >
              Plats
            </button>
            <button
              class="flex-1 py-2.5 px-3 rounded-xl text-sm font-semibold transition-all duration-300"
              :class="[
                visibleTab === 'restaurants'
                  ? 'bg-white text-primary shadow-lg shadow-primary/20'
                  : 'text-slate-500 hover:text-slate-700 hover:bg-white/50'
              ]"
              @click="visibleTab = 'restaurants'"
            >
              Restaurants
            </button>
          </div>
        </div>

        <div class="flex-1 overflow-hidden">
          <DishSearchResultList
            v-if="visibleTab === 'dishes'"
            :searchQuery="searchValue"
            :restaurantId="restaurantId"
          />
          <RestaurantSearchResultList
            v-else-if="visibleTab === 'restaurants'"
            :searchQuery="searchValue"
          />
        </div>
      </div>
    </div>
  </div>

  <DialogComponent
    @closed="
      ({ source }) => {
        source !== 'searchFilter' && disactivateSearch();
      }
    "
    ref="modal"
    type="ui-less"
    v-slot="{ dialogVisible }"
  >
  </DialogComponent>
</template>

<script setup>
import {
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
  getCurrentInstance
} from 'vue';
import CategoriesFiltersTags from '@features/categories-filter-tags/components/CategoriesFiltersTags.vue';
import DishSearchResultList from '@features/dish-search-results/components/DishSearchResultList.vue';
import RestaurantSearchResultList from '@features/restaurant-search-results/components/RestaurantSearchResultList.vue';

const { proxy } = getCurrentInstance();
const { $bus, $constants, $stores } = proxy;

// -----------------------------------------
// PROPS
// -----------------------------------------
const props = defineProps({
  searchOnly: {
    type: Boolean,
    default: false
  },
  onlySearchIconOnCollapse: {
    type: Boolean,
    default: false
  },
  restaurantId: {
    type: String,
    default: ''
  },
  disableDialogRoute: {
    type: Boolean,
    default: false
  },
  showCategoryFilters: {
    type: Boolean,
    default: false
  },
  onlyDiches: {
    type: Boolean,
    default: false
  }
});

// -----------------------------------------
// EMITS
// -----------------------------------------
const emit = defineEmits([
  'search-changed',
  'filters-changed',
  'search-activated',
  'search-deactivated'
]);

// -----------------------------------------
// STATE
// -----------------------------------------
const modal = ref(null);
const searchFilterContainer = ref(null);
const searchFilterComponent = ref(null);
const searchValue = ref('');
const nbFilters = ref(0);
const boxPositionUpdateTimeout = ref(null);
const activeFilters = ref([]);
const searchManualyActivated = ref(false);
const selectedSearchFilters = ref({});
const isSearchFiltersReady = ref(false);
const visibleTab = ref('dishes');

// -----------------------------------------
// COMPUTED
// -----------------------------------------
const searchIsActivated = computed(() => {
  // Check if there are active filters in searchFilters store
  const hasActiveStoreFilters =
    $stores?.searchFilters?.hasActiveFilters || false;

  console.log('[SearchFilter] searchIsActivated check:', {
    activeFilters: activeFilters.value.length,
    searchValue: searchValue.value !== '',
    searchManualyActivated: searchManualyActivated.value,
    nbFilters: nbFilters.value > 0,
    hasActiveStoreFilters
  });

  return (
    activeFilters.value.length > 0 ||
    searchValue.value !== '' ||
    searchManualyActivated.value ||
    nbFilters.value > 0 ||
    hasActiveStoreFilters
  );
});

// -----------------------------------------
// METHODS
// -----------------------------------------
const disactivateSearch = () => {
  searchManualyActivated.value = false;
  searchValue.value = '';
  nbFilters.value = 0;
  activeFilters.value = [];
  // Réinitialiser les filtres du store si la méthode existe
  if ($stores?.searchFilters?.resetFilters) {
    $stores.searchFilters.resetFilters();
  }
  emit('search-deactivated');
};

const manualActivateSearch = () => {
  searchManualyActivated.value = true;
  emit('search-activated');
};

const activateSearch = () => {
  if (!props.disableDialogRoute) {
    // Dialog logic would be implemented as needed
  }
  moveSearchBoxToFixedTop();
};

const moveSearchBoxToFixedTop = () => {
  const box = searchFilterComponent.value;
  if (!box) return;

  const boundingRect = box.getBoundingClientRect();
  box.style.transitionDuration = '0ms';
  box.style.top = boundingRect.top + 'px';
  box.style.left = boundingRect.left + 'px';
  box.style.position = 'fixed';
  box.style.zIndex = '4';

  boxPositionUpdateTimeout.value = setTimeout(() => {
    box.style.transitionDuration = '300ms';
    box.style.top = 0 + 'px';
    box.style.left = 0 + 'px';
  }, 10);
};

const moveSearchBoxToScrollablePosition = () => {
  const boxContainer = searchFilterContainer.value;
  const box = searchFilterComponent.value;
  if (!boxContainer || !box) return;

  const containerRect = boxContainer.getBoundingClientRect();
  box.style.top = containerRect.top + 'px';
  box.style.left = containerRect.left + 'px';

  boxPositionUpdateTimeout.value = setTimeout(() => {
    box.style.position = 'initial';
    box.style.top = 0 + 'px';
    box.style.left = 0 + 'px';
    box.style.zIndex = '4';
  }, 800);
};

const handleFiltersClick = () => {
  console.log('[SearchFilter] Filters button clicked');

  if (!$bus || !$constants) {
    console.error(
      '[SearchFilter] Cannot show filters dialog - $bus or $constants not available'
    );
    return;
  }

  // Emit event to show filters dialog
  $bus.emit($constants.EVENTS.SEARCH_FILTERS.SHOW_DIALOG);
};

const delayedSetNbFilters = (filtersCount) => {
  setTimeout(() => {
    nbFilters.value = filtersCount;
  }, 600);
};

// Calculate active filters count from store
const updateNbFiltersFromStore = () => {
  const filtersStore = $stores?.searchFilters;
  if (!filtersStore) {
    console.warn('[SearchFilter] searchFilters store not available');
    return;
  }

  let count = 0;
  if (filtersStore.state.selectedSort) count++;
  if (filtersStore.state.selectedPriceRange) count++;
  if (filtersStore.state.selectedCategories?.length > 0) count++;

  console.log('[SearchFilter] Updated nbFilters:', count);
  nbFilters.value = count;
};

// Event handlers for filters
const handleFiltersUpdated = (filters) => {
  console.log('[SearchFilter] Filters updated event:', filters);

  // Calculate active filters count
  let count = 0;
  if (filters?.sort) count++;
  if (filters?.priceRange) count++;
  if (filters?.categories?.length > 0) count++;

  console.log('[SearchFilter] Calculated filter count:', count);
  nbFilters.value = count;
};

const handleSearchByCategory = (category) => {
  console.log('Search by category:', category);
  searchValue.value = category.name;
};

// -----------------------------------------
// LIFECYCLE
// -----------------------------------------
onMounted(() => {
  console.log('[SearchFilter] Component mounted');

  // Check if search should be activated on mount
  setTimeout(() => {
    if (searchIsActivated.value) {
      activateSearch();
    }
  }, 500);

  // Set up event listeners
  if (!$bus || !$constants) {
    console.error('[SearchFilter] $bus or $constants not available');
    return;
  }

  $bus.on('search:by_category_requested', handleSearchByCategory);
  // Listen for filters updated from new search-filters feature
  $bus.on(
    $constants.EVENTS.SEARCH_FILTERS.FILTERS_UPDATED,
    handleFiltersUpdated
  );

  // Initialize nbFilters from store
  isSearchFiltersReady.value = true;
  updateNbFiltersFromStore();

  console.log('[SearchFilter] Event listeners registered');
});

onUnmounted(() => {
  console.log('[SearchFilter] Component unmounting');

  // Clean up event listeners
  if (!$bus || !$constants) {
    console.warn(
      '[SearchFilter] $bus or $constants not available during cleanup'
    );
    // Still clean up timeouts
    if (boxPositionUpdateTimeout.value) {
      clearTimeout(boxPositionUpdateTimeout.value);
    }
    return;
  }

  $bus.off('search:by_category_requested', handleSearchByCategory);
  $bus.off(
    $constants.EVENTS.SEARCH_FILTERS.FILTERS_UPDATED,
    handleFiltersUpdated
  );

  // Clean up timeouts
  if (boxPositionUpdateTimeout.value) {
    clearTimeout(boxPositionUpdateTimeout.value);
  }

  console.log('[SearchFilter] Event listeners cleaned up');
});

// -----------------------------------------
// WATCHERS
// -----------------------------------------
watch(searchIsActivated, (newVal) => {
  if (boxPositionUpdateTimeout.value) {
    clearTimeout(boxPositionUpdateTimeout.value);
  }

  if (newVal === true) {
    activateSearch();
    modal.value.show()
  } else {
    if (!props.disableDialogRoute) {
      // Dialog hide logic would be implemented as needed
    }
    moveSearchBoxToScrollablePosition();
    modal.value.hide('searchFilter')
  }
});

watch(searchValue, (newVal) => {
  emit('search-changed', newVal);
});

// Watch searchFilters store for changes to update nbFilters
watch(
  () => $stores?.searchFilters?.hasActiveFilters,
  (hasActiveFilters) => {
    console.log('[SearchFilter] hasActiveFilters changed:', hasActiveFilters);
    if (isSearchFiltersReady.value) {
      updateNbFiltersFromStore();
    }
  }
);

// Watch individual filter states
watch(
  () => $stores?.searchFilters?.state,
  (newState) => {
    console.log('[SearchFilter] searchFilters state changed:', newState);
    if (isSearchFiltersReady.value) {
      updateNbFiltersFromStore();
    }
  },
  { deep: true }
);

// Expose methods for parent component
defineExpose({
  activateSearch: manualActivateSearch,
  disactivateSearch,
  focusSearch: () => {
    const input = searchFilterComponent.value?.querySelector(
      'input[type="search"]'
    );
    input?.focus();
  }
});
</script>

<script>
export default {
  name: 'SearchFilter'
};
</script>

<style scoped>
.title-color {
  color: inherit;
}

.mobile-padding {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.noting {
  /* Note: 'noting' seems to be a typo in original v2 code, keeping for exact design match */
}
</style>
